import { OrderAction } from "./mobile-order-actions";
import preview from "../../assets/img/save_export/preview-dark.svg";
import edit from "../../assets/img/save_export/edit-dark.svg";
import copy from "../../assets/img/save_export/copy-dark.svg";
import download from "../../assets/img/save_export/download-dark.svg";
import share from "../../assets/img/save_export/share-dark.svg";
import remove from "../../assets/img/save_export/delete-dark.svg";
import ticket from "../../assets/img/save_export/tickets.svg";
import whatsapp from "../../assets/img/save_export/whatsapp.svg";

// Mirrors the existing desktop menu permissions; callbacks stay with OrderTable.
export function customerOrderActions(order: any, t: any, handlers: Record<string, () => void>, pending: boolean): OrderAction[] {
  const common = (key: string) => t(key, { ns: "common" });
  const actions: OrderAction[] = [{ id: "preview", label: t("preview", { ns: "newOrder" }), icon: preview, onSelect: handlers.preview }];
  if (order.is_creater) actions.push({ id: "edit", label: common("edit"), icon: edit, to: `/edit-order/${order.id}` });
  actions.push({ id: "duplicate", label: t("Duplicate order", { ns: "interface" }), icon: copy, onSelect: handlers.duplicate, disabled: pending });
  actions.push({ id: "download", label: common("download pdf"), icon: download, onSelect: handlers.download });
  if (!order.is_creater && order.creator_contact_number) actions.push({ id: "message", label: common("send msg"), icon: whatsapp, href: `http://wa.me/972${order.creator_contact_number.slice(1)}` });
  if (order.is_creater) actions.push({ id: "share", label: common("send to supplier"), icon: share, onSelect: handlers.share });
  actions.push({ id: "tickets", label: common("print tickets"), icon: ticket, to: `/ticket-creator/?order_no=${order.order_no}` });
  actions.push({ id: "delete", label: common("delete order"), icon: remove, onSelect: handlers.remove });
  return actions;
}
